const _temp0 = require("../img/work/amazon-clone-1.png");
const _temp1 = require("../img/work/amazon-clone-2.png");
const _temp2 = require("../img/work/amazon-clone-3.png");
const _temp3 = require("../img/work/collection-1.png");
const _temp4 = require("../img/work/collection-2.png");
const _temp5 = require("../img/work/collection-3.png");
const _temp6 = require("../img/work/collection-4.png");
const _temp7 = require("../img/work/collection-5.png");
const _temp8 = require("../img/work/countdown-1.png");
const _temp9 = require("../img/work/game-hub-1.png");
const _temp10 = require("../img/work/game-hub-2.png");
const _temp11 = require("../img/work/game-hub-3.png");
const _temp12 = require("../img/work/mapty-1.png");
const _temp13 = require("../img/work/shoe-sphere-1.png");
const _temp14 = require("../img/work/shoe-sphere-2.png");
const _temp15 = require("../img/work/shoe-sphere-3.png");
const _temp16 = require("../img/work/shoe-sphere-4.png");
const _temp17 = require("../img/work/shoe-sphere-5.png");
const _temp18 = require("../img/work/shoe-sphere-6.png");
module.exports = {
  "amazon-clone-1": _temp0,
  "amazon-clone-2": _temp1,
  "amazon-clone-3": _temp2,
  "collection-1": _temp3,
  "collection-2": _temp4,
  "collection-3": _temp5,
  "collection-4": _temp6,
  "collection-5": _temp7,
  "countdown-1": _temp8,
  "game-hub-1": _temp9,
  "game-hub-2": _temp10,
  "game-hub-3": _temp11,
  "mapty-1": _temp12,
  "shoe-sphere-1": _temp13,
  "shoe-sphere-2": _temp14,
  "shoe-sphere-3": _temp15,
  "shoe-sphere-4": _temp16,
  "shoe-sphere-5": _temp17,
  "shoe-sphere-6": _temp18
}